//export const REAL_IP_SERVER_HTTPS = 'https://178.150.0.40:7073';
export const REAL_IP_SERVER_HTTP = 'http://178.150.0.40:7074';

export const REAL_DOMAIN_SERVER_HTTPS = 'https://api.opticmap.triolan.com.ua';

export const REAL_DOMAIN_RESERVE_SERVER_HTTPS = 'https://api.opticmap2.triolan.com.ua';



export const LOCALHOST = 'https://localhost:7073';

export const SETTING_STRING = `${REAL_DOMAIN_SERVER_HTTPS}`;

//=====================AUTHORIZATION=================================================================================
export const LOGIN_API_URL = `${SETTING_STRING}/api/User/Login`;

export const LOGIN_REFRESH_TOKEN_API_URL = `${SETTING_STRING}/api/User/RefreshToken`;

export const REGISTRATION_API_URL = `${SETTING_STRING}/api/User/Register`;

export const PING_API_URL = `${SETTING_STRING}/api/User/Ping`;
//======================================================================================================

//===================UPDATE====================================================================================
// Update 
export const UPDATE_WELL_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/UpdateWell/`;

export const UPDATE_WELL_OWNER_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/UpdateOwnerWellId/`;

export const UPDATE_PILLAR_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/UpdatePillar/`;

export const UPDATE_PILLAR_OWNER_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/UpdateOwnerPillarId/`;

export const UPDATE_COUPLING_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCoupling/`;

export const UPDATE_COUPLING_NAME_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingId/`;

export const UPDATE_COUPLING_RANK_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingRankId/`;

export const UPDATE_FOB_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFob/`;

export const UPDATE_FOB_NAME_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobId/`;

export const UPDATE_FOB_RANK_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobRankId/`;

export const UPDATE_FOB_RANK_NODE_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobRankNodeId/`;

export const UPDATE_PON_BOX_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBox/`;

export const UPDATE_PON_BOX_NAME_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxId/`;

export const UPDATE_PON_BOX_COMING_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxComing/`;

export const UPDATE_HIGHWAY_LINE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateHighwayLine/`;

export const UPDATE_HIGHWAY_LINE_CONTRACT_NUMBER_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateContractNumberHighwayLine/`;

export const UPDATE_HIGHWAY_LINE_LENGTH_ACT_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateLengthActHighwayLine/`;

export const UPDATE_HIGHWAY_LINE_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableHighwayLine/`;

export const UPDATE_HIGHWAY_CONTRACTOR_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateContractorId/`;

export const UPDATE_HIGHWAY_TYPE_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateTypeCableId/`;

export const UPDATE_RANK_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateRankCableId/`;

export const UPDATE_HIGHWAY_ENGINNER_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateEngineer/`;

export const UPDATE_HIGHWAY_LINE_CABLE_NUMBER_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableNumberHighwayLine/`;

export const UPDATE_WELL_COORDINATE_URL = `${SETTING_STRING}/api/OpticMapWellLocation/UpdatingCoordinatesMapWell/`;

export const UPDATE_PILLAR_COORDINATE_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/UpdatingCoordinatesMapPillar/`;

export const UPDATE_COUPLING_COORDINATE_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdatingCoordinatesMapCoupling/`;

export const UPDATE_FOB_COORDINATE_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdatingCoordinatesMapFob/`;

export const UPDATE_PONBOX_COORDINATE_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatingCoordinatesMapPonBox/`;

export const UPDATE_AMPLIFIER_MODEL_API_URL = `${SETTING_STRING}/api/Ktv/UpdateAmplifierId/`;

export const UPDATE_OP_MODEL_API_URL = `${SETTING_STRING}/api/Ktv/UpdateOpId/`;

export const UPDATE_DIVIDER_MODEL_API_URL = `${SETTING_STRING}/api/Passive/UpdateDividerId/`;

export const UPDATE_DIVIDER_MODEL_PONBOX_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxDividerId/`;

export const UPDATE_DIVIDER_2_MODEL_PONBOX_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxDivider2Id/`;

export const UPDATE_DIVIDER_DESCRIPTION_API_URL = `${SETTING_STRING}/api/Passive/UpdateDividerDescription/`;

export const UPDATE_CASSETTE_MODEL_API_URL = `${SETTING_STRING}/api/Passive/UpdateCassetteId/`;

export const UPDATE_CASSETTE_DESCRIPTION_API_URL = `${SETTING_STRING}/api/Passive/UpdateCassetteDescription/`;

export const UPDATE_PONBOX_NUMBER_BOX_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdateNumberBox/`;

export const UPDATE_PASSIVE_NODE_DESCROPTION_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/UpdatePassiveNodeDescription/`;

export const UPDATE_PASSIVE_NODE_COORDINATE_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/UpdatingCoordinatesMapPassiveNode/`;

export const UPDATE_RESERVE_MODEL_API_URL = `${SETTING_STRING}/api/Reserve/UpdateReserveId/`;

export const UPDATE_RESERVE_DESCRIPTION_API_URL = `${SETTING_STRING}/api/Reserve/UpdateReserveDescription/`;



// Update Status
export const UPDATE_WELL_STATUS_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/UpdateWellStatus/`;

export const UPDATE_PILLAR_STATUS_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/UpdatePillarStatus/`;

export const UPDATE_COUPLING_STATUS_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingStatus/`;

export const UPDATE_FOB_STATUS_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobStatus/`;

export const UPDATE_CABLE_STATUS_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableStatus/`;

export const UPDATE_PON_BOX_STATUS_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxStatus/`;

export const UPDATE_PASSIVE_NODE_STATUS_API_URL = `${SETTING_STRING}/api/Passive/UpdatePassiveNodeStatus/`;

// Update Status ACTIVITY
export const UPDATE_CABLE_STATUS_ACTIVITY_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableStatusActivity/`;

export const UPDATE_AMPLIFIER_STATUS_ACTIVITY_API_URL = `${SETTING_STRING}/api/Ktv/UpdateAmplifierStatusActivity/`;


// Update Status FEATURE
export const UPDATE_CABLE_FEATURE_PON_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableFeaturePon/`;

export const UPDATE_CABLE_FEATURE_KTV_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableFeatureKtv/`;

export const UPDATE_CABLE_FEATURE_ETHER_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableFeatureEther/`;

export const UPDATE_FOB_FEATURE_PON_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobFeaturePon/`;

export const UPDATE_FOB_FEATURE_KTV_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobFeatureKtv/`;

export const UPDATE_FOB_FEATURE_ETHER_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobFeatureEther/`;

export const UPDATE_COUPLING_FEATURE_PON_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingFeaturePon/`;

export const UPDATE_COUPLING_FEATURE_KTV_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingFeatureKtv/`;

export const UPDATE_COUPLING_FEATURE_ETHER_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingFeatureEther/`;

export const UPDATE_PONBOX_FEATURE_PON_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxFeaturePon/`;

export const UPDATE_PONBOX_FEATURE_KTV_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxFeatureKtv/`;

export const UPDATE_PONBOX_FEATURE_ETHER_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxFeatureEther/`;

export const UPDATE_DIVIDER_FEATURE_PON_API_URL = `${SETTING_STRING}/api/Passive/UpdateDividerFeaturePon/`;

export const UPDATE_DIVIDER_FEATURE_KTV_API_URL = `${SETTING_STRING}/api/Passive/UpdateDividerFeatureKtv/`;
//==========================================================================================================

//===================WRITE=======================================================================================
// Editing LineOptic
export const POST_EDITING_CABLE_OPTIC_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/EditingCantonLine`;

export const POST_EDITING_CABLE_OPTIC_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/EditingHighwayLine`;

export const POST_PROBLEM_CABLE_LOCATION_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/PostpProblemCableLocation`;


// Write Canton
export const POST_CABLE_OPTIC_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/PostCableOptic`;

export const POST_WELL_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/PostWell`;

export const POST_PILLAR_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/PostPillar`;

export const POST_COUPLING_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/PostCouplingLocationCanton`;

export const POST_FOB_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/PostFobLocationCanton`;

export const POST_FOB_CANTON_NODE_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/PostFobLocationNode`;

export const POST_FOB_CANTON_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/PostFobLocationPassiveNode`;

export const POST_PON_BOX_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/PostPonBoxLocation`;

export const POST_PON_BOX_CANTON_NODE_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/PostPonBoxLocationNode`;

export const POST_PON_BOX_CANTON_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/PostPonBoxLocationPassiveNode`;

export const POST_KTV_AMPLIFIER_NODE_API_URL = `${SETTING_STRING}/api/Ktv/PostKtvAmplifierNode`;

export const POST_KTV_AMPLIFIER_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Ktv/PostKtvAmplifierPassiveNode`;

export const POST_OP_NODE_API_URL = `${SETTING_STRING}/api/Ktv/PostPostOpticalReceiverNode`; 

export const POST_OP_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Ktv/PostPostOpticalReceiverPassiveNode`; 

export const POST_DIVIDER_NODE_API_URL = `${SETTING_STRING}/api/Passive/PostDividerNode`; 

export const POST_DIVIDER_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Passive/PostDividerPassiveNode`; 

export const POST_CASSETTE_NODE_API_URL = `${SETTING_STRING}/api/Passive/PostCassetteNode`; 

export const POST_CASSETTE_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Passive/PostCassettePassiveNode`; 

export const POST_RESERVE_NODE_API_URL = `${SETTING_STRING}/api/Reserve/PostReserveNode`;


// Write Highway
export const POST_CABLE_OPTIC_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/PostCableOpticHighway`;

export const POST_WELL_HIGHWAY_API_URL = `${SETTING_STRING}/api/EntranceCoordinate/PostWellHighway`;

export const POST_FOB_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/PostFobLocationCity`;

export const POST_PILLAR_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/PostPillar`;

export const POST_PILLAR_MANUALLY_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/PostPillarManuallyCanton`;

export const POST_PILLAR_MANUALLY_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/PostPillarManuallyHighway`;

export const POST_COUPLING_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/PostCouplingLocationCity`;

export const POST_PASSIVE_NODE_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/PostPassiveNodeLocation`;

//Write ConnectionComponents
export const POST_START_HIGHWAY_LINE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/PostStartCableOpticHighway`;

export const POST_END_HIGHWAY_LINE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/PostEndCableOpticHighway`;

export const POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/PostConnectionComponentsCableHighway`;

export const POST_CONNECTION_COMPONENTS_COUPLING_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/PostConnectionComponentsCoupling`;

export const POST_CONNECTION_COMPONENTS_FOB_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/PostConnectionComponentsFob`;

export const POST_CONNECTION_COMPONENTS_PON_BOX_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/PostConnectionComponentsPonBox`;

export const POST_PASSIVE_NODE_HID_ENTRANCE_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/UpdatePassiveNodeHidEntrance/`;


//Write MapsHouseEntranceCoordinates запись координат подъездов
export const POST_HOUSE_ENTRANCE_COORDINATE_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/PostHouseEntrances`;

export const POST_HOUSE_ENTRANCE_COORDINATE_MANUALLY_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/PostHousesEntrancesManually`;

//============================================================================================================

//==================LOADING=============================================================================================

//Search component
export const GET_LINE_OPTIC_ID_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetLineOpticIdCoordinate`;

export const GET_WELL_ID_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetWellId`;

export const GET_PILLAR_ID_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/GetPillarId`;

export const GET_PON_BOX_ID_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxId`;

export const GET_COUPLING_ID_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCouplingLocationId`;

export const GET_FOB_ID_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetFobLocationId`;

export const GET_FOB_COORD_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetFobLocationByCoords`;

export const GET_COUPLING_COORD_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCouplingLocationByCoords`;

export const GET_PON_BOX_COORD_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxByCoords`;

export const GET_PILLAR_COORD_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/GetPillarByCoords`;

export const GET_WELL_COORD_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetWellByCoords`;

export const GET_LINE_OPTIC_COORD_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetLineOpticNearestByCoords`;


//Loading components
export const GET_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetCable`;

export const GET_CABLE_TYPE_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetCableType`;

export const GET_COUPLING_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetCoupling`;

export const GET_FOB_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetFob`;

export const GET_PON_BOX_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetPonBox`;

export const GET_PON_BOX_COMING_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetComingPonBox`;

export const GET_CONTRACTOR_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetContractor`;

export const GET_RANK_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetRankCable`;

export const GET_RANK_COMPONENT_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetRankComponent`;

export const GET_OWNER_WELL_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetOwnerWell`;

export const GET_OWNER_PILLAR_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetOwnerPillar`;

export const GET_KTV_AMPLIFIER_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetKtvAmplifier`;

export const GET_KTV_OP_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetKtvOp`;

export const GET_PROBLEM_TYPE_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetProblemTypeCable`;

export const GET_DIVIDER_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetDivider`;

export const GET_CASSETTE_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetСassette`;

export const GET_RESERVE_API_URL = `${SETTING_STRING}/api/OpticMapMaterial/GetReserve`;


// территория
export const GET_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapTerritory/GetDistinctCantons`;

export const GET_REGION_API_URL = `${SETTING_STRING}/api/OpticMapTerritory/GetDistinctRegion`;

export const GET_AREA_API_URL = `${SETTING_STRING}/api/OpticMapTerritory/GetDistinctArea`;

export const GET_CITY_API_URL = `${SETTING_STRING}/api/OpticMapTerritory/GetDistinctCity`;

export const GET_HOUSE_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/GetHouse`;

export const GET_NUMBER_NODE_API_URL = `${SETTING_STRING}/api/Node/GetNode`;

// Highway отображение территории из фильтра( оборудование, коммуникации)
export const GET_LINE_OPTIC_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetLineOpticHighwayCoordinate`;

export const GET_WELL_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetWellCity`;

export const GET_PILLAR_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/GetPillarCity`;

export const GET_GOUPLING_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCouplingLocationCity`;

export const GET_FOB_HIGHWAY_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetFobLocationCity`;

export const GET_SUMMIT_HIGHWAY_API_URL = `${SETTING_STRING}/api/Equipment/GetSummitCoordinate`;

// Canton отображение территории из фильтра( оборудование, коммуникации)
export const GET_EQUIPMENT_CANTON_API_URL = `${SETTING_STRING}/api/Equipment/GetEquipmentOpticCoordinate`;

export const GET_WELL_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetWell`;

export const GET_PILLAR_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/GetPillar`;

export const GET_COUPLING_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCouplingLocationCoordinate`;

export const GET_FOB_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetFobLocationCoordinateCanton`;

export const GET_PASSIVE_NODE_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/GetPassiveNodeLocationCoordinateCanton`;

export const GET_PON_BOX_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxLocationCoordinateCanton`;

export const GET_PON_BOX_CANTON_NODE_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxLocationNode`;

export const GET_PON_BOX_CANTON_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxLocationPassiveNode`;

export const GET_LINE_OPTIC_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetLineOpticCoordinate`;

export const GET_LINE_OPTIC_BY_ID_CANTON_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetCableOpticCoordinateById`;

export const GET_HOUSES_POLIGON_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/GetAddressPoligon`;

export const GET_KTV_AMPLIFIER_OP_NODE_API_URL = `${SETTING_STRING}/api/Ktv/GetKtvAmplifierOp`;

export const GET_KTV_AMPLIFIER_OP_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Ktv/GetKtvAmplifierOpPassiveNode`;

export const GET_KTV_AMPLIFIER_COORDINATE_API_URL = `${SETTING_STRING}/api/Ktv/GetKtvAmplifierCoordinate`;

export const GET_KTV_AMPLIFIER_PASSIVE_NODE_COORDINATE_API_URL = `${SETTING_STRING}/api/Ktv/GetKtvAmplifierPassiveNodeCoordinate`;

export const GET_KTV_OP_COORDINATE_API_URL = `${SETTING_STRING}/api/Ktv/GetKtvOpCoordinate`;

export const GET_DIVIDER_NODE_API_URL = `${SETTING_STRING}/api/Passive/GetDividerNode`;

export const GET_DIVIDER_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Passive/GetDividerPassiveNode`;

export const GET_DIVIDER_COORDINATE_API_URL = `${SETTING_STRING}/api/Passive/GetDividerCoordinate`;

export const GET_CASSETTE_NODE_API_URL = `${SETTING_STRING}/api/Passive/GetCassetteNode`;

export const GET_CASSETTE_PASSIVE_NODE_API_URL = `${SETTING_STRING}/api/Passive/GetCassettePassiveNode`;

export const GET_RESERVE_NODE_API_URL = `${SETTING_STRING}/api/Reserve/GetReserveNode`;



//==================CONNECTION COMPONENTS=============================================================================================
// ConnectionComponents связи компонентов
export const GET_START_HIGHWAY_LINE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetStartHighwayLine`;

export const GET_END_HIGHWAY_LINE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetEndHighwayLine`;

export const GET_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetCableConnection`;

export const GET_COUNT_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetCountHighwayLineIdConnection`;

export const GET_PILLAR_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetPillarConnection`;

export const GET_COUNT_PILLAR_CONNECTION_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/GetCountPillarConnection`;

export const GET_WELL_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetWellConnection`;

export const GET_COUNT_WELL_CONNECTION_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetCountWellConnection`;

export const GET_COUPLING_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetCouplingConnection`;

export const GET_COUNT_COUPLING_CONNECTION_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCountCouplingConnection`;

export const GET_FOB_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetFobConnection`;

export const GET_COUNT_FOB_CONNECTION_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetCountFobConnection`;

export const GET_PON_BOX_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetPonBoxConnection`;

export const GET_COUNT_PON_BOX_CONNECTION_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetCountPonBoxConnection`;

export const GET_HOUSE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetHouseConnection`;

export const GET_NODE_CONNECTION_API_URL = `${SETTING_STRING}/api/Equipment/GetCountNodeConnection`;

export const GET_RUOTE_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/GetRouteCableConnection`;


// удаление связей
//CABLE
export const DELETE_CABLE_COUPLING_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCableCoupling`;

export const DELETE_CABLE_FOB_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCableFob`;

export const DELETE_CABLE_PON_BOX_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCablePonBox`;

export const DELETE_CABLE_PILLAR_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCablePillar`;

export const DELETE_CABLE_WELL_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCableWell`;

export const DELETE_CABLE_CASSETTE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCableCassette`;

export const DELETE_CABLE_HOUSE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCableHouse`;

export const DELETE_CABLE_LINE_PERENT_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCableLineParent`;

export const DELETE_START_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionStartCable`;

export const DELETE_END_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionEndCable`;

//PILLAR
export const DELETE_PILLAR_COUPLING_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPillarCoupling`;

export const DELETE_PILLAR_FOB_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPillarFob`;

export const DELETE_PILLAR_PON_BOX_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPillarPonBox`;

export const DELETE_PILLAR_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPillarCable`;

//WELL
export const DELETE_WELL_COUPLING_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionWellCoupling`;

export const DELETE_WELL_FOB_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionWellFob`;

export const DELETE_WELL_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionWellCable`;

//COUPLING
export const DELETE_COUPLING_HOUSE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCouplingHouse`;

export const DELETE_COUPLING_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCouplingCable`;

export const DELETE_COUPLING_WELL_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCouplingWell`;

export const DELETE_COUPLING_PILLAR_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionCouplingPillar`;

//FOB
export const DELETE_FOB_HOUSE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionFobHouse`;

export const DELETE_FOB_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionFobCable`;

export const DELETE_FOB_WELL_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionFobWell`;

export const DELETE_FOB_PILLAR_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionFobPillar`;

//PON_BOX
export const DELETE_PON_BOX_HOUSE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPonBoxHouse`;

export const DELETE_PON_BOX_CABLE_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPonBoxCable`;

export const DELETE_PON_BOX_PILLAR_CONNECTION_API_URL = `${SETTING_STRING}/api/ConnectionComponents/DeleteConnectionPonBoxPillar`;

//=======================================================================================================================================

// Актуализация территории
export const GET_AREA_UPDATING_TERRITORY_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/GetAreaAddress`;

export const DELETE_HOUSE_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/DeleteHouse/`;

export const UPDATE_HOUSE_ENTRANCE_API_URL = `${SETTING_STRING}/api/UpdatingTerritory/UpdateHouseEntrance`;


// Загрузка Логов
export const GET_LOGS_API_URL = `${SETTING_STRING}/api/Log/GetLog`;

export const GET_LOGS_TRAFFIC_API_URL = `${SETTING_STRING}/api/User/Attendance`;

export const GET_LOGS_ATTENDANCE_API_URL = `${SETTING_STRING}/api/Administration/GetAttendance`;


//=================== Актуализация оптики ======================================================================================================
export const GET_REGION_UPDATING_OPTIC_API_URL = `${SETTING_STRING}/api/UpdatingOptic/GetRegoinOptics`;

export const UPLOAD_CABLE_UPDATING_FOTO_API_URL = `${SETTING_STRING}/api/UpdatingOptic/UploadCableUpdatingFoto`;

export const GET_CABLE_UPDATING_FOTO_API_URL = `${SETTING_STRING}/api/UpdatingOptic/GetCableUpdatingFoto`;

export const DELETE_CABLE_UPDATING_FOTO_API_URL = `${SETTING_STRING}/api/UpdatingOptic/DeleteCableUpdatingFoto`;

//==================File=============================================================================================

//Foto
export const UPLOAD_GOUPLING_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UploadCouplingPhoto`;
 
export const GET_GOUPLING_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCouplingPhotos`;

export const GET_COUNT_GOUPLING_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCountCouplingPhotos`;

export const DELETE_GOUPLING_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/DeleteCouplingPhoto`;

export const UPLOAD_FOB_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UploadFobPhoto`;

export const GET_FOB_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetFobPhotos`;

export const GET_COUNT_FOB_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetCountFobPhotos`;

export const DELETE_FOB_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/DeleteFobPhoto`;

export const UPLOAD_NODE_FOTO_API_URL = `${SETTING_STRING}/api/Equipment/UploadNodePhoto`;

export const GET_NODE_FOTO_API_URL = `${SETTING_STRING}/api/Equipment/GetNodePhotos`;

export const GET_COUNT_NODE_FOTO_API_URL = `${SETTING_STRING}/api/Equipment/GetCountNodePhotos`;

export const DELETE_NODE_FOTO_API_URL = `${SETTING_STRING}/api/Equipment/DeleteNodePhoto`;

export const GET_COUNT_PASSIVE_NODE_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/GetCountPassiveNodePhotos`;

export const UPLOAD_PASSIVE_NODE_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/UploadPassiveNodePhoto`;

export const GET_PASSIVE_NODE_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/GetPassiveNodePhotos`;

export const DELETE_PASSIVE_NODE_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPassiveNodeLocation/DeletePassiveNodePhoto`;

export const UPLOAD_WELL_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/UploadWellPhoto`;

export const GET_WELL_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetWellPhotos`;

export const GET_COUNT_WELL_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetCountWellPhotos`;

export const DELETE_WELL_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/DeleteWellPhoto`;

export const GET_PON_BOX_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxPhotos`;

export const UPLOAD_PON_BOX_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UploadPonBoxPhoto`;

export const DELETE_PON_BOX_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/DeletePonBoxPhoto`;

export const GET_COUNT_PON_BOX_FOTO_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetCountPonBoxPhotos`;

// PDF
export const UPLOAD_HIGHWAY_LINE_PDF_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UploadCablePdf`;

export const GET_HIGHWAY_LINE_PDF_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetCablePdf`;

export const DELETE_HIGHWAY_LINE_PDF_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/DeleteCablePdf`;

export const GET_COUNT_LINE_PDF_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetCountHighwayLinePdf`;

//================= Administration ==============================================================================

//получить описание компонента
export const GET_ADMIN_COMPONENT_ID_API_URL = `${SETTING_STRING}/api/Administration/GetComponentId`;

export const GET_ADMIN_LIST_STATUS_COMPONENT_API_URL = `${SETTING_STRING}/api/Administration/GetListStatus`;

// удалить по ID
export const DELETE_ADMIN_PILLAR_ID_API_URL = `${SETTING_STRING}/api/Administration/DeletePillarLocationData`;

export const DELETE_ADMIN_WELL_ID_API_URL = `${SETTING_STRING}/api/Administration/DeleteWellLocationData`;

export const DELETE_ADMIN_COUPLING_ID_API_URL = `${SETTING_STRING}/api/Administration/DeleteCouplingLocationData`;

export const DELETE_ADMIN_FOB_ID_API_URL = `${SETTING_STRING}/api/Administration/DeleteFobLocationData`;

export const DELETE_ADMIN_CABLE_ID_API_URL = `${SETTING_STRING}/api/Administration/DeleteCableLocationData`;

export const DELETE_ADMIN_PONBOX_ID_API_URL = `${SETTING_STRING}/api/Administration/DeletePonBoxLocationData`;

export const DELETE_AMPLIFIER_ID_API_URL = `${SETTING_STRING}/api/Ktv/DeleteAmplifier`;

export const DELETE_DIVIDER_ID_API_URL = `${SETTING_STRING}/api/Passive/DeleteDivider`;

export const DELETE_CASSETTE_ID_API_URL = `${SETTING_STRING}/api/Passive/DeleteCassette`;

export const DELETE_OP_ID_API_URL = `${SETTING_STRING}/api/Ktv/DeleteOp`;

export const DELETE_PROBLEM_LINE_ID_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/DeleteProblemLocation`;

export const UPDATE_PROBLEM_LINE_COMMENT_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCommentProblemLocation/`;

export const DELETE_RESERVE_ID_API_URL = `${SETTING_STRING}/api/Reserve/DeleteReserve`;

//============== FasteningErrors ==================================================================================

export const GET_FASTENING_ERRORS_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetCableLoose`;

export const UPDATE_FASTENING_ERRORS_CABLE_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/UpdateCableArea/`;

export const GET_FASTENING_ERRORS_CABLE_ID_API_URL = `${SETTING_STRING}/api/OpticMapCableLocation/GetCableLooseId`;

export const GET_FASTENING_ERRORS_PON_BOX_ID_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/GetPonBoxLooseId`;

export const UPDATE_FASTENING_ERRORS_POB_BOX_API_URL = `${SETTING_STRING}/api/OpticMapPonBoxLocation/UpdatePonBoxArea/`;

export const GET_FASTENING_ERRORS_COUPLING_ID_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/GetCouplingLooseId`;

export const UPDATE_FASTENING_ERRORS_COUPLING_API_URL = `${SETTING_STRING}/api/OpticMapCouplingLocation/UpdateCouplingArea/`;

export const GET_FASTENING_ERRORS_FOB_ID_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/GetFobLooseId`;

export const UPDATE_FASTENING_ERRORS_FOB_API_URL = `${SETTING_STRING}/api/OpticMapFobLocation/UpdateFobArea/`;

export const UPDATE_FASTENING_ERRORS_PILLAR_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/UpdatePillarArea/`;

export const GET_FASTENING_ERRORS_PILLAR_ID_API_URL = `${SETTING_STRING}/api/OpticMapPillarLocation/GetPillarLooseId`;

export const UPDATE_FASTENING_ERRORS_WELL_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/UpdateWellArea/`;

export const GET_FASTENING_ERRORS_WELL_ID_API_URL = `${SETTING_STRING}/api/OpticMapWellLocation/GetWellLooseId`;


// удалить все записи где Status=0
export const DELETE_ADMIN_COMPONENTS_STATUS_API_URL = `${SETTING_STRING}/api/Administration/DeleteComponentStatusLocationData`;

// восстановить по ID запись где Status=0
export const RESTORED_ADMIN_COMPONENT_STATUS_API_URL = `${SETTING_STRING}/api/Administration/UpdateComponentStatus/`;

//============== Statistics ==================================================================================

export const GET_STATISTICS_CABLE_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsCable`;

export const GET_STATISTICS_CABLE_HIGHWAY_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsCableHighway`;

export const GET_STATISTICS_COMPONENT_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsComponent`;

export const GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsActualization`;

export const GET_STATISTICS_CABLE_CANTON_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsCableCanton`;

export const GET_STATISTICS_CABLE_ACCOUNT_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsCableAccount`;

export const GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsInfrastructure`;

export const GET_STATISTICS_CABLE_EXCEL_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsCableDownloads`;

export const GET_STATISTICS_ACCOUNT_EXCEL_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsAccountDownloads`;

export const GET_STATISTICS_CABLE_SUBWAY_3K_EXCEL_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsCableSubway3kDownloads`;

export const GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsActualizationOptic`;

export const GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsUpdatingOpticDownloads`;

export const GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsUpdatingOpticRaportDownloads`;

export const GET_STATISTICS_ACTIVE_KTV_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsActivKtv`;

export const GET_STATISTICS_PILLAR_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsPillarCanton`;

export const GET_STATISTICS_WELL_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsWellCanton`;

export const GET_STATISTICS_3K_CHAIN_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsChain3kCanton`;

export const GET_STATISTICS_100PAB_CHAIN_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsChain100PabCanton`;

export const GET_STATISTICS_SUBWAY_CANTON_API_URL = `${SETTING_STRING}/api/Statistics/GetSubwaysCantonStatistics`;

export const GET_STATISTICS_WIFI_CITY_API_URL = `${SETTING_STRING}/api/Statistics/GetStatisticsWifiCity`;

export const GET_STATISTICS_100PAB_IN_ENTRANCE_API_URL = `${SETTING_STRING}/api/Statistics/GetStatistics100pabInEntranceCanton`;

export const GET_STATISTICS_SUBWAY_CITY_API_URL = `${SETTING_STRING}/api/Statistics/GetSubwaysCityStatistics`;

//================AutoTopology================================================================================
export const GET_EQUIPMENT_AUTO_TOPOLOGY_API_URL = `${SETTING_STRING}/api/AutoTopology/GetAutoTopologyEquipment`;
//============================================================================================================

//=================OTHER========================================================================================
// ссылка на netstat
export const NETSTAT_SWITCH_URL = 'https://engineer.triolan.net.ua/m/sw.php'

// ссылка на netstat
export const NETSTAT_SWITCH_TOPO_URL = 'https://engineer.triolan.net.ua/m/tree?'

// ссылка на service house
export const SERVICE_HOUSE_URL = 'https://service1.triolan.com/Territory/House'

//================= Command ========================================================================================

export const GET_EQUIPMENT_TYPE_COMMAND_API_URL = `${SETTING_STRING}/api/Command/GetEquipmentType`;

export const GET_COMMAND_API_URL = `${SETTING_STRING}/api/Command/GetCommand`;

//=============================NODES=====================================================================================

export const GET_NODES_SW_API_URL = `${SETTING_STRING}/api/Node/GetNodeSw`;

export const GET_NODES_TOPO_SW_API_URL = `${SETTING_STRING}/api/Node/GetNodeTopo`;

export const GET_3K_NODE_API_URL = `${SETTING_STRING}/api/Node/Get3k`;


//=============================FLOOD=====================================================================================

export const GET_FLOOD_PACKAGES_FULL_LOG_API_URL = `${SETTING_STRING}/api/Flood/GetPackagesBroadcast`;

export const GET_FLOOD_ABON_LOG_API_URL = `${SETTING_STRING}/api/Flood/GetFloodAbonBroadcast`;

//=============================CONSTRUCTOR=====================================================================================

export const POST_NEW_PROJECT_API_URL = `${SETTING_STRING}/api/ConstructionProject/PostNewProject`;

export const GET_PROJECTS_API_URL = `${SETTING_STRING}/api/ConstructionProject/GetProjects`;

export const DELETE_PROJECT_API_URL = `${SETTING_STRING}/api/ConstructionProject/DeleteProject/`;

export const POST_CABLE_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/PostCableConstructor`;

export const GET_CABLE_PROJECT_CONSTRTUCT_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/GetCabeOpticCoordinateConstruct`;

export const GET_CABLE_BY_ID_PROJECT_CONSTRTUCT_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/GetCableOpticCoordinateById`;

export const POST_COUPLING_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/PostCouplingLocationConstructor`;

export const GET_COUPLING_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/GetCouplingLocationConstructor`;

export const POST_FOB_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/PostFobLocationConstruction`;

export const GET_FOB_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/GetFobLocationConstructor`;

export const POST_PON_BOX_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/PostPonBoxLocationConstruction`;

export const GET_PON_BOX_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/GetPonBoxLocationConstruction`;

export const POST_EDITING_CABLE_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/EditingCableLineConstruction`;

export const UPDATE_CABLE_ID_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateCableIdConstruction/`;

export const UPDATE_TYPE_CABLE_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateTypeCableConstructionId/`;

export const UPDATE_CABLE_LENGTH_ACT_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateCableLengthActConstruction/`;

export const UPDATE_RANK_CABLE_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateRankCableConstructionId/`;

export const UPDATE_CABLE_CONTRACTOR_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateContractorContructionId/`;

export const UPDATE_CABLE_DESCRIPTION_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateCableDescriptionConstruction/`;

export const DELETE_CABLE_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/DeleteCableConstruction`;

export const GET_CABLE_SINGLE_REFRESH_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/GetCableSingleRefreshConstruct`;

export const UPDATE_COUPLING_NAME_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/UpdateCouplingNameConstructionId/`;

export const UPDATE_COUPLING_RANK_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/UpdateCouplingRankConstructionId/`;

export const UPDATE_COUPLING_DESCRIPTION_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/UpdateCouplingDescriptionConstruction/`;

export const UPDATE_COUPLING_COORDINATE_CONSTRUCTOR_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/UpdatingCoordinatesCouplingConstruction/`;

export const DELETE_COUPLING_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/DeleteCouplingConstruction`;

export const DELETE_FOB_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/DeleteFobConstruction`;

export const UPDATE_FOB_NAME_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdateFobNameConstructionId/`;

export const UPDATE_FOB_RANK_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdateFobRankConstructionId/`;

export const UPDATE_FOB_DESCRIPTION_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdateFobDescriptionConstriction/`;

export const UPDATE_FOB_COORDINATE_CONSTRUCTION_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdatingCoordinatesFobConstruction/`;

export const DELETE_PONBOX_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/DeletePonBoxConstruction`;

export const UPDATE_PONBOX_DESCRIPTION_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdatePonBoxDescriptionConstruction/`;

export const UPDATE_PONBOX_NAME_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdatePonBoxConstructionId/`;

export const UPDATE_DIVIDER_MODEL_PONBOX_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdatePonBoxDividerConstructionId/`;

export const UPDATE_DIVIDER_2_MODEL_PONBOX_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdatePonBoxDivider2ConstructionId/`;

export const UPDATE_PONBOX_NUMBER_BOX_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdateNumberBoxConstruction/`;

export const UPDATE_PONBOX_COORDINATE_CONSTRUCTION_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdatingCoordinatesPonBoxConstruction/`;

export const UPDATE_DIVIDER_MODEL_FOB_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdateFobDividerConstructionId/`;

export const GET_ESTIMATE_API_URL = `${SETTING_STRING}/api/Estimate/GetEstimate`;

export const GET_HOUSES_POLIGON_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionProject/GetAddressPoligonConstruction`;

export const GET_POLISHING_COUSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/GetPolishingConstruction`;

export const GET_BOX_COUSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/GetBoxConstruction`;

export const UPDATE_BOX_MODEL_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdateBoxModelConstructionId/`;

export const UPDATE_ADAPTER_PIGTAIL_COUNT_FOB_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionFobLocation/UpdateAdapterPigtailConstructionId/`;

export const UPDATE_ADAPTER_PIGTAIL_COUNT_PON_BOX_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionPonBoxLocation/UpdateAdapterPigtailPonBoxConstructionId/`;

export const UPDATE_WELDIND_COUNT_COUPLING_CONSTRUCTION_API_URL = `${SETTING_STRING}/api/ConstructionCouplingLocation/UpdateWeldingCouplingConstructionId/`;

export const UPDATE_CABLE_FORWARDING_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateForwardingContruction/`;

export const UPDATE_CABLE_CASSETTE_PATCH_CONSTRUCTOR_API_URL = `${SETTING_STRING}/api/ConstructionCableLocation/UpdateCassettePatchContructionId/`;

export const GET_PASSIVE_NODE_AMPLIFIER_API_URL = `${SETTING_STRING}/api/ConstructionPassiveNodeLocation/GetPassiveNodeAmplifierLocationCoordinate`;

export const GET_PROJECT_BY_ID_API_URL = `${SETTING_STRING}/api/ConstructionProject/GetProjectById`;

//============================= WI-FI =====================================================================================

export const GET_WIFI_MODEL_API_URL = `${SETTING_STRING}/api/WifiLocation/GetModelWifi`;

export const GET_WIFI_TYPE_API_URL = `${SETTING_STRING}/api/WifiLocation/GetTypeWifi`;

export const POST_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLocation/PostWifiPointLocation`;

export const GET_WIFI_POINT_LOCATION_API_URL = `${SETTING_STRING}/api/WifiLocation/GetWifiPointLocationCoordinate`;

export const GET_WIFI_POINT_BY_ID_LOCATION_API_URL = `${SETTING_STRING}/api/WifiLocation/GetWifiPointLocationById`;

export const UPDATE_TYPE_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateTypeWifiPointId/`;

export const UPDATE_MODEL_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateModelWifiPointId/`;

export const UPDATE_IP_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateIpPointWifiId/`;

export const UPDATE_MAC_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateMacPointWifiId/`;

export const UPDATE_LOGIN_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateLoginPointWifiId/`;

export const UPDATE_PASSWORD_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdatePasswordPointWifiId/`;

export const UPDATE_IP_PORT_UPLINK_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateIpPortUplinkPointWifiId/`;

export const UPDATE_CONTROLLER_IP_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateControllerIpPointWifiId/`;

export const UPDATE_DESCRIPTION_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateDescriptionPointWifi/`;

export const DELETE_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLocation/DeleteWifiPoint`;

export const UPDATE_AREA_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateAreaPointWifi/`;

export const UPDATE_AZIMUTH_POINT_WIFI_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateAzimuthPointWifiId/`;

export const UPDATE_WIFI_POINT_COORDINATE_URL = `${SETTING_STRING}/api/WifiLocation/UpdatingCoordinatesMapWifiPoint/`;

export const UPDATE_WIFI_PLANNED_STATUS_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateWifiPlannedStatus/`;

export const GET_WIFI_POINT_MONITORING_API_URL = `${SETTING_STRING}/api/WifiLocation/GetMonitoringIpWifi`;

export const GET_COUNT_WIFI_POINT_PHOTO_API_URL = `${SETTING_STRING}/api/WifiLocation/GetCountWifiPointPhotos`;

export const UPLOAD_WIFI_POINT_PHOTO_API_URL = `${SETTING_STRING}/api/WifiLocation/UploadWifiPointPhoto`;

export const GET_PHOTO_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLocation/GetPhotoWifiPoint`;

export const DELETE_PHOTO_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLocation/DeleteWifiPointPhoto`;

export const GET_LOG_WIFI_POINT_API_URL = `${SETTING_STRING}/api/WifiLog/GetWifiLog`;

export const UPDATE_WIFI_POINT_STATUS_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateStatusWifiPoint/`;

export const UPDATE_WIFI_POINT_HID_ENTRANCE_API_URL = `${SETTING_STRING}/api/WifiLocation/UpdateHidEntrancePointWifiId/`;

